// extracted by mini-css-extract-plugin
module.exports = {"item":"TabItem_item__KFC9S","isActive":"TabItem_isActive__NaxX_"};